// external imports
import { commitMutation } from 'react-relay'
// local imports
import env from '~/relayEnv'

const mutationFromQuery = query => (input, callbacks) =>
    commitMutation(env, {
        mutation: query,
        variables: { input },
        onError: callbacks.onFailure,
        onCompleted: callbacks.onSuccess,
        ...callbacks
    })

export default mutationFromQuery



// WEBPACK FOOTER //
// ./src/mutations/mutationFromQuery.js